import script from "./AuthIknowaInfoMobileModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthIknowaInfoMobileModal.vue?vue&type=script&setup=true&lang=js"

import "./AuthIknowaInfoMobileModal.vue?vue&type=style&index=0&id=440bb000&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-440bb000"]])

export default __exports__